import React from 'react';

import PersonalInformationPage from 'components/personal-information-page';

const RegisterPage = props => <PersonalInformationPage {...props} />;

RegisterPage.propTypes = PersonalInformationPage.propTypes;

export default RegisterPage;
